import * as React from 'react';
import { connect } from 'react-redux';
import store from '../store/store';
import types from '../store/types';
import { ErrorDisplay } from '../components';

class ErrorDisplayContainer extends React.Component<any, any> {

	closeError () {

		store.dispatch({
			type: types.CLOSE_ERROR
		});

	}

	render () {

		let { error, hasBeenClosed } = this.props.state;

		return (
			
			error && !hasBeenClosed ? 
				<ErrorDisplay 
					error={error}
					components={this.props.components}
					closeError={this.closeError}
				/> : null
		);

	}

}

let mapStateToProps = (store) => {
	
	return {
		state: store.errorState,
		components: store.processState.components
	};
};

export default connect<any, any, any>(mapStateToProps)(ErrorDisplayContainer);


// WEBPACK FOOTER //
// ./source/ts/containers/error-display.tsx